module.exports = __webpack_public_path__ + "img/logo.c24aa26f.png";